import axios from './axios';

export default {
  getProjects: async query => {
    const params = { params: query };
    const { data } = await axios.get(`/portlet/projects`, params);
    return data;
  },

  getLatestMembers: async query => {
    const params = { params: query };
    const { data } = await axios.get(`/portlet/latest-members`, params);
    return data;
  },

  getMemberDocumentKinds: async (profileId, query) => {
    const params = { params: query };
    const { data } = await axios.get(
      `/portlet/profiles/${profileId}/document-kinds`,
      params
    );
    return data;
  },

  getLatestDocuments: async query => {
    const params = { params: query };
    const { data } = await axios.get(`/portlet/latest-documents`, params);
    return data;
  },

  getLatestItineraries: async query => {
    const params = { params: query };
    const { data } = await axios.get(`/portlet/latest-itineraries`, params);
    return data;
  }
};
